import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup'
import {setElementInnerHTML, createParagraphIn, createDivIn, createImgIn} from '../../../shared/scripts/ui_utils/DomUtils'
import {navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils'
import {ReferralProgram} from '../../../../shared/ReferralProgram'

export class ViewPopupPushReferrersToInviteMoreFriends extends ViewPopup {
    constructor(referralCount: number, abTestGroupId: string) {
        const getFreeMapButtonAction = async() => {
            switch(abTestGroupId) {
                case 'GROUP_B_MESSAGE':
                    navigateToPage('/store#referrals=showpopupgroupb')
                    break
                case 'GROUP_C_POPUP':
                    navigateToPage('/store#referrals=showpopupgroupc')
                    break
                default:
                    navigateToPage('/store#referrals')
                    break
            }
        }

        super({key: 'strings:homePage.popups.pushReferrersToInviteMoreFriends.title'},
            {key: 'strings:colonistCommon.utils.emptyString'},
            getFreeMapButtonAction,
            () => undefined, true,
            {
                showXButton: false,
                showCheckButton: true,
                showXonHeader: false,
            })

        this.init(referralCount)
        this.show()
    }

    private init(referralCount: number) {
        this.body.style.flexDirection = 'column'

        const remainingReferrals = ReferralProgram.referralRewardLevels[1].referralCount - referralCount

        setElementInnerHTML(this.body, {key: 'strings:colonistCommon.utils.emptyString'})
        createParagraphIn(this.body, {key: 'strings:homePage.popups.pushReferrersToInviteMoreFriends.body', options: {count: remainingReferrals, remainingReferrals: remainingReferrals}}, 'popup-membership-body')

        const container = createDivIn(this.body, 'no-vertical-spacing', '')
        const imageWrapper = createDivIn(container, 'popup-subscription-in-room-items-wrapper', '')

        const mapRewardLevel = ReferralProgram.referralRewardLevels[1]
        mapRewardLevel.possibleRewards.forEach((map) => {
            const imageCard = createDivIn(imageWrapper, 'popup-subscription-in-room-item-img', '')
            createImgIn(imageCard, map.image)
            createParagraphIn(imageCard, map.name, 'popup-map-name')
            imageWrapper.appendChild(imageCard)
        })

        this.changeCheckButtonText({key: 'strings:homePage.popups.pushReferrersToInviteMoreFriends.button'})
    }
}
